module.exports = __webpack_public_path__ + "plus-2021jump/images/bleach.1a11679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/items/bleach.jpg
// module id = yspv
// module chunks = 0